const deskTopMenuOnly = ['venue-builder'];
export { deskTopMenuOnly };
